<template>
	<div>
		<h1>Szakkörök</h1>
    <v-tabs
      v-model="aktivtab"
      color="primary"
      icons-and-text
    >
      <v-tab v-if="adatok.csoportvezeto">Szakkörellenőrzés<v-icon>fa-users</v-icon></v-tab>
      <v-tab>Szakkörigazolás<v-icon>fa-lightbulb</v-icon></v-tab>
      <v-tab-item v-if="adatok.csoportvezeto">
        <v-data-table
          :headers="tablazatok.szakkorellenorzes.fejlec"
          :items="adatok.diakok.filter(d => adatok.csoportid==-1? true : d.csoportid==adatok.csoportid)"
          sort-by="nev"
          multi-sort

        >
          <template v-slot:group.header="{ group, headers, toggle, isOpen, groupBy, remove }">
            <td :colspan="headers.length">
              <v-tooltip top>
                <template v-slot:activator="{on, attrs}">
                  <v-btn @click="toggle" x-small icon v-on="on" v-bind="attrs" :ref="group">
                     <v-icon v-if="isOpen">fa-minus</v-icon>
                     <v-icon v-else>fa-plus</v-icon>
                 </v-btn>
                </template>
                {{isOpen ? "Összecsukás" : "Kinyitás"}}
              </v-tooltip>

               <v-icon v-if="groupBy=='csoportnev'">fa-users</v-icon>
               <span class="mx-5 font-weight-bold" v-if="groupBy=='csoportnev'">{{group}}{{(group!="-"? " - Csoportvezető: "+adatok.csoportok.find(cs => cs.csoportnev==group).nev:"")}}</span>
               <span class="mx-5 font-weight-bold" v-else>{{groupBy+": "+group}}</span>
               <v-tooltip top>
                 <template v-slot:activator="{on, attrs}">
                   <v-btn icon @click="remove" v-bind="attrs" v-on="on"><v-icon>fa-times</v-icon></v-btn>
                 </template>
                 A csoportosítás megszüntetése
               </v-tooltip>
            </td>
          </template>
          <template v-slot:item.nev="{item}">
            <v-tooltip top>
              <template v-slot:activator="{on,attrs}">
                <span v-on="on" v-bind="attrs">{{item.nev}}</span>
              </template>
                <span>{{adatok.minositesek.find(m => m.id==item.minosites).minositesnev}} {{item.szobanev? ", "+item.szobanev:"" }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.csoportnev="{item}">
            <span v-if="item.csoportnev=='-'">-</span>
            <v-tooltip top v-else>
              <template v-slot:activator="{on,attrs}">
                <span v-on="on" v-bind="attrs">{{item.csoportnev}}</span>
              </template>
              <span>Csoportvezető: {{adatok.csoportok.find(cs => cs.id==item.csoportid).nev}}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.jelenlet9="{item}">
            <v-tooltip top>
              <template v-slot:activator="{on,attrs}">
                <v-icon v-bind="attrs" v-on="on" color="success" v-if="adatok.szakkoromonjelenlet.filter(szj => szj.diakid==item.id&&szj.jelenlet9==1).length>0">fa-check</v-icon>
                <v-icon v-bind="attrs" v-on="on" color="red accent-4" v-else>fa-times</v-icon>
              </template>
              {{ellenorzotooltipszoveg(item.id,9)}}
            </v-tooltip>
          </template>
          <template v-slot:item.jelenlet10="{item}">
            <v-tooltip top>
              <template v-slot:activator="{on,attrs}">
                <v-icon v-bind="attrs" v-on="on" color="success" v-if="adatok.szakkoromonjelenlet.filter(szj => szj.diakid==item.id&&szj.jelenlet10==1).length>0">fa-check</v-icon>
                <v-icon v-bind="attrs" v-on="on" color="red accent-4" v-else>fa-times</v-icon>
              </template>
              {{ellenorzotooltipszoveg(item.id,10)}}
            </v-tooltip>
          </template>
          <template v-slot:item.jelenlet11="{item}">
            <v-tooltip top>
              <template v-slot:activator="{on,attrs}">
                <v-icon v-bind="attrs" v-on="on" color="success" v-if="adatok.szakkoromonjelenlet.filter(szj => szj.diakid==item.id&&szj.jelenlet11==1).length>0">fa-check</v-icon>
                <v-icon v-bind="attrs" v-on="on" color="red accent-4" v-else>fa-times</v-icon>
              </template>
              {{ellenorzotooltipszoveg(item.id,11)}}
            </v-tooltip>
          </template>
          <template v-slot:item.jelenlet12="{item}">
            <v-tooltip top>
              <template v-slot:activator="{on,attrs}">
                <v-icon v-bind="attrs" v-on="on" color="success" v-if="adatok.szakkoromonjelenlet.filter(szj => szj.diakid==item.id&&szj.jelenlet12==1).length>0">fa-check</v-icon>
                <v-icon v-bind="attrs" v-on="on" color="red accent-4" v-else>fa-times</v-icon>
              </template>
              {{ellenorzotooltipszoveg(item.id,12)}}
            </v-tooltip>
          </template>
          <template v-slot:item.jelenlet1="{item}">
            <v-tooltip top>
              <template v-slot:activator="{on,attrs}">
                <v-icon v-bind="attrs" v-on="on" color="success" v-if="adatok.szakkoromonjelenlet.filter(szj => szj.diakid==item.id&&szj.jelenlet1==1).length>0">fa-check</v-icon>
                <v-icon v-bind="attrs" v-on="on" color="red accent-4" v-else>fa-times</v-icon>
              </template>
              {{ellenorzotooltipszoveg(item.id,1)}}
            </v-tooltip>
          </template>
          <template v-slot:item.jelenlet2="{item}">
            <v-tooltip top>
              <template v-slot:activator="{on,attrs}">
                <v-icon v-bind="attrs" v-on="on" color="success" v-if="adatok.szakkoromonjelenlet.filter(szj => szj.diakid==item.id&&szj.jelenlet2==1).length>0">fa-check</v-icon>
                <v-icon v-bind="attrs" v-on="on" color="red accent-4" v-else>fa-times</v-icon>
              </template>
              {{ellenorzotooltipszoveg(item.id,2)}}
            </v-tooltip>
          </template>
          <template v-slot:item.jelenlet3="{item}">
            <v-tooltip top>
              <template v-slot:activator="{on,attrs}">
                <v-icon v-bind="attrs" v-on="on" color="success" v-if="adatok.szakkoromonjelenlet.filter(szj => szj.diakid==item.id&&szj.jelenlet3==1).length>0">fa-check</v-icon>
                <v-icon v-bind="attrs" v-on="on" color="red accent-4" v-else>fa-times</v-icon>
              </template>
              {{ellenorzotooltipszoveg(item.id,3)}}
            </v-tooltip>
          </template>
          <template v-slot:item.jelenlet4="{item}">
            <v-tooltip top>
              <template v-slot:activator="{on,attrs}">
                <v-icon v-bind="attrs" v-on="on" color="success" v-if="adatok.szakkoromonjelenlet.filter(szj => szj.diakid==item.id&&szj.jelenlet4==1).length>0">fa-check</v-icon>
                <v-icon v-bind="attrs" v-on="on" color="red accent-4" v-else>fa-times</v-icon>
              </template>
              {{ellenorzotooltipszoveg(item.id,4)}}
            </v-tooltip>
          </template>
          <template v-slot:item.jelenlet5="{item}">
            <v-tooltip top>
              <template v-slot:activator="{on,attrs}">
                <v-icon v-bind="attrs" v-on="on" color="success" v-if="adatok.szakkoromonjelenlet.filter(szj => szj.diakid==item.id&&szj.jelenlet5==1).length>0">fa-check</v-icon>
                <v-icon v-bind="attrs" v-on="on" color="red accent-4" v-else>fa-times</v-icon>
              </template>
              {{ellenorzotooltipszoveg(item.id,5)}}
            </v-tooltip>
          </template>
          <template v-slot:item.jelenlet6="{item}">
            <v-tooltip top>
              <template v-slot:activator="{on,attrs}">
                <v-icon v-bind="attrs" v-on="on" color="success" v-if="adatok.szakkoromonjelenlet.filter(szj => szj.diakid==item.id&&szj.jelenlet6==1).length>0">fa-check</v-icon>
                <v-icon v-bind="attrs" v-on="on" color="red accent-4" v-else>fa-times</v-icon>
              </template>
              {{ellenorzotooltipszoveg(item.id,6)}}
            </v-tooltip>
          </template>
        </v-data-table>
      </v-tab-item>

      <v-tab-item>
        <v-data-table
          :headers="tablazatok.szakkorigazolas.fejlec"
          :items="adatok.szakkorok.filter(sz => sz.enszakkorom)"
          show-expand
          single-expand
          sort-by="szakkornev"
					v-if="adatok.szakkorok"
        >
          <template v-slot:group.header="{ group, headers, toggle, isOpen, groupBy, remove }">
            <td :colspan="headers.length">
              <v-tooltip top>
                <template v-slot:activator="{on, attrs}">
                  <v-btn @click="toggle" x-small icon v-on="on" v-bind="attrs" :ref="group">
                     <v-icon v-if="isOpen">fa-minus</v-icon>
                     <v-icon v-else>fa-plus</v-icon>
                 </v-btn>
                </template>
                {{isOpen ? "Összecsukás" : "Kinyitás"}}
              </v-tooltip>

               <v-icon v-if="groupBy=='nev'">fa-chalkboard-teacher</v-icon>
               <span class="mx-5 font-weight-bold" v-if="groupBy=='nev'">Szakkörvezető: {{group}}</span>
               <span class="mx-5 font-weight-bold" v-else>{{groupBy+": "+group}}</span>
               <v-tooltip top>
                 <template v-slot:activator="{on, attrs}">
                   <v-btn icon @click="remove" v-bind="attrs" v-on="on"><v-icon>fa-times</v-icon></v-btn>
                 </template>
                 A csoportosítás megszüntetése
               </v-tooltip>
            </td>
          </template>

          <template v-slot:item.letszam="{item}">
            {{adatok.szakkoromonjelenlet.filter(szj => szj.szakkorid==item.id).length}} fő
          </template>

          <template v-slot:expanded-item="{headers, item}">
            <td :colspan="headers.length">
              <v-data-table
                :headers="tablazatok.szakkorigazolas.igazolas.fejlec"
                :items="adatok.szakkoromonjelenlet.filter(szj => szj.szakkorid==item.id)"
                hide-default-footer
                disable-pagination
                sort-by="nev"
                multi-sort
              >
                <template v-slot:top>
                  <v-tooltip top>
                    <template v-slot:activator="{on, attrs}">
                      <v-btn fab right v-on="on" color="primary" v-bind="attrs" @click="dialogusok.ujtanuloszakkorhoz.mutat=true, dialogusok.ujtanuloszakkorhoz.szakkorid=item.id"><v-icon>fa-user-plus</v-icon></v-btn>
                    </template>
                    Új tanuló hozzáadása a szakkörhöz
                  </v-tooltip>
                </template>
                <template v-slot:group.header="{ group, headers, toggle, isOpen, groupBy, remove }">
                  <td :colspan="headers.length">
                    <v-tooltip top>
                      <template v-slot:activator="{on, attrs}">
                        <v-btn @click="toggle" x-small icon v-on="on" v-bind="attrs" :ref="group">
                           <v-icon v-if="isOpen">fa-minus</v-icon>
                           <v-icon v-else>fa-plus</v-icon>
                       </v-btn>
                      </template>
                      {{isOpen ? "Összecsukás" : "Kinyitás"}}
                    </v-tooltip>

                     <v-icon v-if="groupBy=='csoportnev'">fa-users</v-icon>
                     <span class="mx-5 font-weight-bold" v-if="groupBy=='csoportnev'">{{group}}</span>
                     <span class="mx-5 font-weight-bold" v-else>{{groupBy+": "+group}}</span>
                     <v-tooltip top>
                       <template v-slot:activator="{on, attrs}">
                         <v-btn icon @click="remove" v-bind="attrs" v-on="on"><v-icon>fa-times</v-icon></v-btn>
                       </template>
                       A csoportosítás megszüntetése
                     </v-tooltip>
                  </td>
                </template>
                <template v-slot:item.nev="props">
                  <v-tooltip top>
                    <template v-slot:activator="{on,attrs}">
                      <span v-on="on" v-bind="attrs">{{props.item.nev}}</span>
                    </template>
                      <span>{{adatok.minositesek.find(m => m.id==props.item.minosites).minositesnev}} {{props.item.szobanev? ", "+props.item.szobanev:"" }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:item.csoportnev="props">
                  <span v-if="props.item.csoportnev=='-'">-</span>
                  <v-tooltip top v-else>
                    <template v-slot:activator="{on,attrs}">
                      <span v-on="on" v-bind="attrs">{{props.item.csoportnev}}</span>
                    </template>
                    <span>Csoportvezető: {{adatok.csoportok.find(cs => cs.id==props.item.csoportid).nev}}</span>
                  </v-tooltip>
                </template>
                <template v-slot:item.jelenlet9="props">
                  <v-checkbox readonly @click="jelenletvaltoztatas(props.item.diakid,item.id,9)" v-model="props.item.jelenlet9==1" :indeterminate="props.item.jelenlet9==2"></v-checkbox>
                </template>
                <template v-slot:item.jelenlet10="props">
                  <v-checkbox readonly @click="jelenletvaltoztatas(props.item.diakid,item.id,10)" v-model="props.item.jelenlet10==1" :indeterminate="props.item.jelenlet10==2"></v-checkbox>
                </template>
                <template v-slot:item.jelenlet11="props">
                  <v-checkbox readonly @click="jelenletvaltoztatas(props.item.diakid,item.id,11)" v-model="props.item.jelenlet11==1" :indeterminate="props.item.jelenlet11==2"></v-checkbox>
                </template>
                <template v-slot:item.jelenlet12="props">
                  <v-checkbox readonly @click="jelenletvaltoztatas(props.item.diakid,item.id,12)" v-model="props.item.jelenlet12==1" :indeterminate="props.item.jelenlet12==2"></v-checkbox>
                </template>
                <template v-slot:item.jelenlet1="props">
                  <v-checkbox readonly @click="jelenletvaltoztatas(props.item.diakid,item.id,1)" v-model="props.item.jelenlet1==1" :indeterminate="props.item.jelenlet1==2"></v-checkbox>
                </template>
                <template v-slot:item.jelenlet2="props">
                  <v-checkbox readonly @click="jelenletvaltoztatas(props.item.diakid,item.id,2)" v-model="props.item.jelenlet2==1" :indeterminate="props.item.jelenlet2==2"></v-checkbox>
                </template>
                <template v-slot:item.jelenlet3="props">
                  <v-checkbox readonly @click="jelenletvaltoztatas(props.item.diakid,item.id,3)" v-model="props.item.jelenlet3==1" :indeterminate="props.item.jelenlet3==2"></v-checkbox>
                </template>
                <template v-slot:item.jelenlet4="props">
                  <v-checkbox readonly @click="jelenletvaltoztatas(props.item.diakid,item.id,4)" v-model="props.item.jelenlet4==1" :indeterminate="props.item.jelenlet4==2"></v-checkbox>
                </template>
                <template v-slot:item.jelenlet5="props">
                  <v-checkbox readonly @click="jelenletvaltoztatas(props.item.diakid,item.id,5)" v-model="props.item.jelenlet5==1" :indeterminate="props.item.jelenlet5==2"></v-checkbox>
                </template>
                <template v-slot:item.jelenlet6="props">
                  <v-checkbox readonly @click="jelenletvaltoztatas(props.item.diakid,item.id,6)" v-model="props.item.jelenlet6==1" :indeterminate="props.item.jelenlet6==2"></v-checkbox>
                </template>
                <template v-slot:item.torles="props">
                  <v-tooltip top>
      							<template v-slot:activator="{on, attrs}">
      								<v-btn icon v-bind="attrs" v-on="on" color="red accent-4" @click="torlesdialogus(props.item.diakid,item.id)"><v-icon>fa-trash</v-icon></v-btn>
      							</template>
      							Törlés
      						</v-tooltip>
                </template>
              </v-data-table>
            </td>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
    <v-dialog
				v-model="dialogusok.ujtanuloszakkorhoz.mutat"
				persistent
				max-width="600px"
		>

				<v-card>
					<v-card-title>
						<span class="headline" v-if="dialogusok.ujtanuloszakkorhoz.mutat">Tanuló hozzáadása a(z) {{adatok.szakkorok.find(sz => sz.id==dialogusok.ujtanuloszakkorhoz.szakkorid).szakkornev}} szakkörhöz</span>
					</v-card-title>
					<v-card-text>
						<v-container v-if="dialogusok.ujtanuloszakkorhoz.mutat">

							<v-select
								prepend-inner-icon="fa-user"
								label="Tanuló"
								:items="adatok.diakok.filter(d => adatok.szakkoromonjelenlet.findIndex(szj => szj.szakkorid==dialogusok.ujtanuloszakkorhoz.szakkorid&&szj.diakid==d.id)==-1)"
								v-model="dialogusok.ujtanuloszakkorhoz.diakid"
								item-value="id"
								item-text="nev"
							>
								<template v-slot:item="{item}">
									{{item.nev+(item.csoportnev? (" - "+item.csoportnev):"")}}
								</template>
							</v-select>

						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="blue darken-1"
							text
							@click="dialogusok.ujtanuloszakkorhoz.mutat=false"
						>
							Mégsem<v-icon>fa-times</v-icon>
						</v-btn>
						<v-btn
							color="success"
							text
							v-if="dialogusok.ujtanuloszakkorhoz.diakid>-1"
							@click="ujtanuloszakkorhoz"
						>
							Hozzáadás<v-icon>fa-user-plus</v-icon>
						</v-btn>
					</v-card-actions>
				</v-card>
		</v-dialog>
    <v-dialog
				v-model="dialogusok.torles.mutat"
				persistent
				max-width="600px"
		>

				<v-card>
					<v-card-title>
						<span class="headline" >Tanuló törlése egy szakkörből</span>
					</v-card-title>
					<v-card-text>
						<v-container >
              <span v-if="dialogusok.torles.mutat">Biztos törli {{adatok.diakok.find(d => d.id==dialogusok.torles.tanuloid).nev}} tanulót a(z) {{adatok.szakkorok.find(sz => sz.id==dialogusok.torles.szakkorid).szakkornev}} szakkör tagjai közül?</span>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="blue darken-1"
							text
							@click="dialogusok.torles.mutat=false"
						>
							Mégsem<v-icon>fa-times</v-icon>
						</v-btn>
						<v-btn
							color="red accent-4"
							text
							v-if=""
							@click="torles"
						>
							Törlés<v-icon>fa-trash</v-icon>
						</v-btn>
					</v-card-actions>
				</v-card><!--Új szoba-->
		</v-dialog>
		<template>
  		<v-snackbar
  		 v-model="snackbar.megnyit"
  		>
  		 {{ snackbar.szoveg }}
  		 <v-btn
  			 color="pink"
  			 text
  			 @click="snackbar.megnyit = false"
  		 >
  			 Bezár
  		 </v-btn>
  		</v-snackbar>
	</template>

	</div>
</template>

<script>
	import router from '../router';
	export default {
		data: function(){
			return {
        aktivtab: 0,
        snackbar: {
          megnyit: false,
          szoveg: ""
        },
        tablazatok: {
          szakkorellenorzes: {
            fejlec: [
              {
                text: "Tanuló",
                value: "nev",
                align: "right",
                sortable: true,
                filterable: true,
                groupable: false
              },
              {
                text: "Csoport",
                value: "csoportnev",
                align: "right",
                sortable: true,
                filterable: false,
                groupable: true
              },
              {
                text: "IX.",
                value: "jelenlet9",
                align: "right",
                sortable: false,
                filterable: false,
                groupable: false
              },
              {
                text: "X.",
                value: "jelenlet10",
                align: "right",
                sortable: false,
                filterable: false,
                groupable: false
              },
              {
                text: "XI.",
                value: "jelenlet11",
                align: "right",
                sortable: false,
                filterable: false,
                groupable: false
              },
              {
                text: "XII.",
                value: "jelenlet12",
                align: "right",
                sortable: false,
                filterable: false,
                groupable: false
              },
              {
                text: "I.",
                value: "jelenlet1",
                align: "right",
                sortable: false,
                filterable: false,
                groupable: false
              },
              {
                text: "II.",
                value: "jelenlet2",
                align: "right",
                sortable: false,
                filterable: false,
                groupable: false
              },
              {
                text: "III.",
                value: "jelenlet3",
                align: "right",
                sortable: false,
                filterable: false,
                groupable: false
              },
              {
                text: "IV.",
                value: "jelenlet4",
                align: "right",
                sortable: false,
                filterable: false,
                groupable: false
              },
              {
                text: "V.",
                value: "jelenlet5",
                align: "right",
                sortable: false,
                filterable: false,
                groupable: false
              },
              {
                text: "VI.",
                value: "jelenlet6",
                align: "right",
                sortable: false,
                filterable: false,
                groupable: false
              },
            ]
          },
          szakkorigazolas: {
            igazolas: {
              fejlec: [
                {
  								text: "Tanuló",
  								value: "nev",
  								align: "right",
  								sortable: true,
  								filterable: true,
  								groupable: false
  							},
                {
                  text: "Csoport",
                  value: "csoportnev",
                  align: "right",
                  sortable: true,
                  filterable: true,
                  groupable: true
                },
                {
  								text: "IX.",
  								value: "jelenlet9",
  								align: "left",
  								sortable: false,
  								filterable: false,
  								groupable: false
  							},
                {
  								text: "X.",
  								value: "jelenlet10",
  								align: "left",
  								sortable: false,
  								filterable: false,
  								groupable: false
  							},
                {
  								text: "XI.",
  								value: "jelenlet11",
  								align: "left",
  								sortable: false,
  								filterable: false,
  								groupable: false
  							},
                {
  								text: "XII.",
  								value: "jelenlet12",
  								align: "left",
  								sortable: false,
  								filterable: false,
  								groupable: false
  							},
                {
  								text: "I.",
  								value: "jelenlet1",
  								align: "left",
  								sortable: false,
  								filterable: false,
  								groupable: false
  							},
                {
  								text: "II.",
  								value: "jelenlet2",
  								align: "left",
  								sortable: false,
  								filterable: false,
  								groupable: false
  							},
                {
  								text: "III.",
  								value: "jelenlet3",
  								align: "left",
  								sortable: false,
  								filterable: false,
  								groupable: false
  							},
                {
  								text: "IV.",
  								value: "jelenlet4",
  								align: "left",
  								sortable: false,
  								filterable: false,
  								groupable: false
  							},
                {
  								text: "V.",
  								value: "jelenlet5",
  								align: "left",
  								sortable: false,
  								filterable: false,
  								groupable: false
  							},
                {
  								text: "VI.",
  								value: "jelenlet6",
  								align: "left",
  								sortable: false,
  								filterable: false,
  								groupable: false
  							},
                {
                  text: "Törlés",
                  value: "torles",
                  align: "center",
                  sortable: false,
                  filterable: false,
                  groupable: false
                }
              ]
            },
            fejlec: [
                {
  								text: "Szakkör",
  								value: "szakkornev",
  								align: "center",
  								sortable: true,
  								filterable: true,
  								groupable: false
  							},
                {
  								text: "Időpontja és helye",
  								value: "idoponteshely",
  								align: "center",
  								sortable: false,
  								filterable: true,
  								groupable: false
  							},
                {
                  text: "Szakkörvezető",
                  value: "nev",
                  align: "center",
                  sortable: true,
                  filterable: true,
                  groupable: true
                },
                {
                  text: "Létszám",
                  value: "letszam",
                  align: "center",
                  sortable: true,
                  filterable: false,
                  groupable: false
                }
            ]
          }
        },
        dialogusok: {
          ujtanuloszakkorhoz: {
            mutat: false,
            szakkorid: -1,
            tanuloid: -1,
          },
          torles: {
            mutat: false,
            szakkorid: -1,
            tanuloid: -1
          }
        },
        adatok: {}
      }
		},
		computed: {

		},
		watch: {

		},
		methods: {
      ellenorzotooltipszoveg: function(diak,honap) {
        var szoveg="";
        this.adatok.szakkoromonjelenlet.filter(szj => szj.diakid==diak).forEach(szj => {
          var szakkor=this.adatok.szakkorok.find(sz => sz.id==szj.szakkorid)
          szoveg+=szakkor.szakkornev+" ("+szakkor.nev+"): "+(szj["jelenlet"+honap]==1? "OK": "-")+", "
        })
        return szoveg;
      },
      torles: function() {
        this.axios.delete(this.$store.state.backendeleres+"szakkorok/"+this.dialogusok.torles.szakkorid+"/"+this.dialogusok.torles.tanuloid)
                  .then((response) => {
                    if(response.data.bejelentkezve==false) this.kijelentkezes();
                    if(response.data.ok) {
                      this.adatok.szakkoromonjelenlet.splice(this.adatok.szakkoromonjelenlet.findIndex(szj => szj.szakkorid==this.dialogusok.torles.szakkorid&&szj.diakid==this.dialogusok.torles.tanuloid),1);
                      this.dialogusok.torles.mutat=false;
                      this.snackbar.szoveg="A törlés sikeresen végbement."
                      this.snackbar.mutat=true;
                    }
                    else {
                      this.snackbar.szoveg="A törlés hibába ütközött: "+response.data.hiba;
                      this.snackbar.mutat=true;
                    }
                  })
      },
      torlesdialogus: function(tanuloid,szakkorid){
        this.dialogusok.torles.tanuloid=tanuloid;
        this.dialogusok.torles.szakkorid=szakkorid;
        this.dialogusok.torles.mutat=true;
      },
      ujtanuloszakkorhoz: function() {
        this.axios.post(this.$store.state.backendeleres+"szakkorok/ujtanulo",this.dialogusok.ujtanuloszakkorhoz)
                  .then((response) => {
                    if(response.data.bejelentkezve==false)this.kijelentkezes();
                    if(response.data.ok){
                      var diak = this.adatok.diakok.find(f => f.id==this.dialogusok.ujtanuloszakkorhoz.diakid);
                      this.adatok.szakkoromonjelenlet.push(
                        {diakid: this.dialogusok.ujtanuloszakkorhoz.diakid, szakkorid: this.dialogusok.ujtanuloszakkorhoz.szakkorid,
                          nev: diak.nev, csoportnev: diak.csoportnev||"-", csoportid: diak.csoportid||null,
                          minosites: diak.minosites, szobanev: diak.szobanev,
                          jelenlet9: 0, jelenlet10: 0, jelenlet11: 0, jelenlet12: 0, jelenlet1: 0, jelenlet2: 0,
                          jelenlet3: 0, jelenlet4: 0, jelenlet5: 0, jelenlet6: 0 }
                      );
                      this.dialogusok.ujtanuloszakkorhoz.mutat=false;
                      this.snackbar.szoveg="A hozzáadás sikeresen végbement."
                      this.snackbar.mutat=true;
                    }
                    else {
                      this.snackbar.szoveg="A hozzáadás hibába ütközött: "+response.data.hiba;
                      this.snackbar.mutat=true;
                    }
                  })
      },
      jelenletvaltoztatas: function(diakid, szakkorid, honap) {
        this.axios.post(this.$store.state.backendeleres+"szakkorok/jelenletvaltoztatas",{diakid, szakkorid, honap})
                  .then((response) => {
                    if(response.data.bejelentkezve==false) this.kijelentkezes();
                    if(response.data.ok) {
                      var szakkorjelenlet = this.adatok.szakkoromonjelenlet.find(szj => szj.diakid==diakid&&szj.szakkorid==szakkorid);
                      szakkorjelenlet["jelenlet"+honap]= (szakkorjelenlet["jelenlet"+honap]+1)%3;
                    }
                  })
      }
		},
		mounted(){
			this.axios.get(this.$store.state.backendeleres+"szakkorok").then((response) => {
				if(response.data.ok){
          this.adatok=response.data.adatok;
          this.adatok.szakkoromonjelenlet.forEach(szj => {
            if(!szj.csoportnev) szj.csoportnev="-"
          })
          this.adatok.diakok.forEach(d => {
            if(!d.csoportnev) d.csoportnev="-";
          })
				}
        if(response.data.bejelentkezve== false) this.kijelentkezes();
			})
		}
	}
</script>
